import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {environment} from "../../../environments/environment";
import { ActivatedRoute } from '@angular/router';
import { ApiPathsService } from 'src/app/api-paths.service';
import { Azienda } from 'src/app/Admin/models/Azienda';
import { ToastrService } from 'ngx-toastr';
import {CampoUtility} from "../../shared/models/campo-aggiuntivo";
import { TaskService } from '../_service/task.service';

@Component({
  selector: 'app-news',
  templateUrl: './clienti-task.component.html',
  styleUrls: ['./clienti-task.component.scss']
})
export class ClientiTaskComponent implements OnInit {
   tipo!: string;
   TaskStucture: any;
   Task:any = {};
   environment = environment;
   Data = this;
   Clienti: Azienda[] = [];
   fields:any[] = [
    {nome: 'Ospiti',  oggetti: ['Clienti'], type:"table", header:[{nome: "Seleziona", oggetti: ['selected'], inputType:'checkbox', modificabile: true},{nome: "Ospite", oggetti: ['fullName']}], modificabile: true, class: 'col-lg-12', azioni:[ ]},

   ];


constructor (
    private activeRoute:ActivatedRoute,
    private apiPaths: ApiPathsService,
    private ToastService: ToastrService,
    private campoUtility: CampoUtility,
    private TaskService: TaskService
  ) { }



ngOnInit(): void {
    this.activeRoute.params.subscribe(
        (params: {tipo: string}) => {
          this.tipo = params.tipo;
          this.TaskStucture = this.campoUtility.getDynamicTaskSctructure(this.tipo);
        }
      );
      this.apiPaths.ClassicPost('/anagrafica/clienti/list', {page: 0, size: 10, ruolo:'C'}).subscribe(data=>this.Clienti = data?.data ?? [])
  }
  save(){
   
    console.log('Clienti Selezionati: ', this.Clienti.filter(x=>x['selected']));
    var selected = this.Clienti.filter(x=>x['selected']);
    if(!(selected?.length>0)){
      this.ToastService.warning("Selezionare almeno un ospite");
      return;
    }
    //todo validazione
    selected.forEach(cliente => {
      var task = Object.assign({},this.Task);
      task.categorie = []
      task.categorie.push(task.categoria)
      console.log("task", task);
      task.cliente = cliente.id;
      task.clienteObject = cliente;
      if(!this.ValidateError(task)) return;
      this.apiPaths.ClassicPost(`${this.TaskStucture.restRoute}/add`, task).subscribe(data=>cliente['selected'] = false)
    })

  }
  ValidateError(oggetto){
    return this.campoUtility.ValidateError(oggetto,this.TaskStucture.campi)
  }
}
